module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargadorDerecha-dd-9039f93f.png";